import { render, staticRenderFns } from "./ChooseClass.vue?vue&type=template&id=2fb1eb9a&"
import script from "./ChooseClass.vue?vue&type=script&lang=js&"
export * from "./ChooseClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports